import {
  AccountDetailForSelector,
  AccountProductEnum,
  InternalCheckingAccount,
  Query,
} from '@varo/graphql-schema-types';
import myAccountsQuery from 'services/graphql/queries/MoveMoney/GetMyAccounts';
import { useQuery } from 'urql';

interface UsePaymentPlanAccountResult {
  account: AccountDetailForSelector | null;
  fetching: boolean;
}

const usePaymentPlanAccount = (): UsePaymentPlanAccountResult => {
  const [{ data, fetching }] = useQuery<Query>({
    query: myAccountsQuery,
    requestPolicy: 'cache-and-network',
  });

  const checkingAccount = data?.myAccounts?.internal?.find(
    (account): account is InternalCheckingAccount => {
      return account?.product === AccountProductEnum.Checking;
    },
  );

  if (
    !checkingAccount?.id ||
    !checkingAccount.accountNumber ||
    !checkingAccount.accountNumberLast4 ||
    !checkingAccount.availableBalance?.formatted ||
    !checkingAccount.iconUrl ||
    !checkingAccount.name
  ) {
    return { account: null, fetching };
  }

  return {
    account: {
      accountId: checkingAccount.id,
      accountNumber: checkingAccount.accountNumber,
      accountNumberLast4: checkingAccount.accountNumberLast4,
      availableBalance: checkingAccount.availableBalance,
      iconURL: checkingAccount.iconUrl,
      name: checkingAccount.name,
      nickname: checkingAccount.nickname ?? checkingAccount.name,
    },
    fetching,
  };
};

export default usePaymentPlanAccount;
